import { useQuery } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import {
  APQueryOptions,
  SHORT_STALE_TIME,
  useAPQuery,
} from "../../providers/APQueryProvider";
import { DossierSavingsSummary } from "../../types/Dossier";
import {
  LimitPaginationFilters,
  LimitPaginationResponse,
} from "../../types/Pagination";

export const getMyEmployerDossierSavingsSummaries = (
  filters: LimitPaginationFilters & {
    sortBy: "annualSavings" | "annualisedPayrollTaxSaving";
  },
  options: APQueryOptions = {}
) => {
  const { fetchWithAuth } = useApi();
  const { isQueryEnabled } = useAPQuery();
  const { pageNumber, pageSize, sortBy } = filters;

  return useQuery({
    queryKey: ["employerDossierSavingsSummaries", filters],
    queryFn: (): Promise<LimitPaginationResponse<DossierSavingsSummary>> => {
      return fetchWithAuth<LimitPaginationResponse<DossierSavingsSummary>>(
        "getMyEmployerDossierSavingsSummaries",
        undefined,
        {
          queryParams: {
            pageNumber: `${pageNumber}`,
            pageSize: pageSize ? `${pageSize}` : undefined,
            sortBy: sortBy ? `${sortBy}` : undefined,
          },
        }
      );
    },
    enabled: isQueryEnabled(options),
    keepPreviousData: options.keepPreviousData,
    staleTime: SHORT_STALE_TIME,
  });
};
